/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};


(function () {
  'use strict';
  _.extend(Backbone.history, {
    navigate: function (fragment, options) {
      if (!Backbone.History.started) {
        return false;
      }
      if (!options || options === true) {
        options = {trigger: !!options};
      }
      if (options.rootUrl) {
        this.root = options.rootUrl;
      }
      var url = this.root + (fragment = this.getFragment(fragment || ''));
      if (this.fragment === fragment) {
        Backbone.trigger('UrlParamsNotChanged');
      }
      if (options.rootUrl && options.trigger) {
        if (url[0] !== '/') {
          url = '/' + url;
        }
        return this.location.assign(url);
      }
      this.fragment = fragment;
      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
        
        // If hash changes haven't been explicitly disabled, update the hash
        // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            this.iframe.document.open().close();
          }
          this._updateHash(this.iframe.location, fragment, options.replace);
        }
        
        // If you've told us that you explicitly don't want fallback hashchange-
        // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) {
        return this.loadUrl(fragment);
      }
    },
    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function (fragment) {
      var result;
      try {
        result = decodeURI(fragment.replace(/%25/g, '%2525'));
      } catch (e) {
        result = fragment.replace(/%25/g, '%2525');
      }
      
      return result;
    }
  });
})();

}.call(window));